/*
 * P&F DRE web application
 *
 * Show/hide more detail about each error.
 */

import React from 'react';

import './styles.css';

interface Props {
	children: React.ReactNode;
};

const ShowMore: React.FC<Props> = (props) => {
	const [visible, setVisible] = React.useState(false);
	return (
		<span className="ShowMore">
			<span
				className="moreText"
				onClick={() => setVisible(!visible)}
			>
				{visible ? 'show less' : 'show more...'}
			</span>
			<div
				className="moreContent"
				style={{ display: visible ? 'block' : 'none' }}
			>
				{props.children}
			</div>
		</span>
	);
}

export default ShowMore;
